import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import ObjectTypeLabel from 'flow-doctor-lib/components/common/ObjectTypeLabel';
import { getObjectTypeIdFromObject } from 'flow-doctor-lib/utils/eventFilterUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const EventReenrollmentAnalysisReason = ({
  diagnosisReason,
  selectedEnrollment
}) => {
  return /*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: 'flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.enrollTypeReason.description.EVENT_RE_ENROLL_jsx',
      elements: {
        ObjectTypeLabel,
        b: 'b'
      },
      options: {
        objectTypeId: getObjectTypeIdFromObject(diagnosisReason.event.eventTypeId),
        portalId: selectedEnrollment.portalId
      }
    })
  });
};
export default EventReenrollmentAnalysisReason;